module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAAAQCAYAAADgfRjGAAAA80lEQVRoQ+3bMQ7CMAyFYXvgTO5xGFg5A8cAiRP5TpWMMlCBoIVErTvk7xipdfPFb0jUqrtfI+KkqjczOwsXAgikCqi7R6kYEeMwDIfU6hRDAAGZQlgszEwxQQCBXAFCmOtNNQQ+BAghTYHAzgKEcOcFoDwCsyHk1JTmQCBHYCmEnJrmrAFVOhf4GUJOTTvvEKa/uQAh3JyYAggsC1SHsGWv6O4XFgIBBL4LtISweq9ICGk/BOYFmkPIXpG2QmAdAUK4jiNPQaBZ4DWEo5lNH3A/P+wWkb/Gm9+AGxHoXKCE8C4iRxF5+5WpdrxzR6aPQLPAA6EPo8XzxqwJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/A10_xgsm/titleR.png
// module id = zz2d
// module chunks = 0